"use client";
import SeachFormsCampaignListener from "@/components/SeachFormsCampaignListener";
import BottomSheet from "@/components/ui/BottomSheet";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import Image from "next/image";
import { useState } from "react";
import { cdnCommonPath } from "@/constants/cdnUrls";

const LayoutWrapper = ({
  children,
  pnrFormComponent: PnrFormComponent,
  translationNamespace = "common",
  hidePnrSection,
  hideCampaignListener = false,
}) => {
  const t = useTranslationDetector();
  const [isPnrModalOpen, setIsPnrModalOpen] = useState(false);

  const handlePnrClick = () => {
    setIsPnrModalOpen(true);
  };

  const closePnrModal = () => {
    setIsPnrModalOpen(false);
  };

  // BottomSheet handles mobile gating, animations and body scroll lock internally

  return (
    <div className="flex flex-col gap-4 md:gap-6">
      {/* Ana form */}

      {children}

      {!hideCampaignListener && (
        <SeachFormsCampaignListener wrapperClassName="order-1 lg:order-2" />
      )}

      {/* Mobile PNR & Check-In Butonları */}

      {!hidePnrSection && (
        <div className="shadow-small order-1 flex items-center justify-center rounded-lg bg-white/90 md:hidden">
          <button
            onClick={handlePnrClick}
            className="inline-flex w-full items-center justify-center gap-4 p-6 text-sm font-medium"
          >
            <Image
              src={`${cdnCommonPath}online-cancel.svg`}
              alt={t(`${translationNamespace}.pnrSearch`)}
              width={40}
              height={40}
              className="!h-10 !w-10"
            />
            <span className="text-left">
              {t(`${translationNamespace}.reservationSearch`)}
            </span>
          </button>
        </div>
      )}

      {/* PNR BottomSheet */}
      {PnrFormComponent && (
        <BottomSheet
          isOpen={isPnrModalOpen}
          onClose={closePnrModal}
          title={t(`${translationNamespace}.reservationSearch`)}
        >
          <PnrFormComponent onClose={closePnrModal} />
        </BottomSheet>
      )}
    </div>
  );
};

export default LayoutWrapper;
